import { Dictionary, EntityAdapter } from '@ngrx/entity';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { BaseSelector } from './base-selector.model';
import { BaseState } from './base-state.model';

/* eslint-disable  @typescript-eslint/no-explicit-any */

/* eslint-disable  @typescript-eslint/no-unsafe-function-type */
export abstract class ApiSelector<S, T, P, F> extends BaseSelector<S, BaseState<T, P, F>> {
  selectAdapter: any;

  selectIds: (state: object) => string[] | number[];
  selectEntities: (state: object) => Dictionary<T>;
  selectAll: (state: object) => T[];
  selectTotal: (state: object) => number;

  selectSelectedEntity: MemoizedSelector<object, NonNullable<T> | null>;
  selectCurrentEntity: MemoizedSelector<object, T | null>;
  selectSelectedId: MemoizedSelector<object, string | null>;
  selectPagination: MemoizedSelector<object, P | null>;
  selectPlatformResponse: MemoizedSelector<
    object,
    {
      data: T[];
      currentPage: number;
      hasMore: boolean;
      limit: number;
      maxPage: number;
      total: number;
    }
  >;
  selectTotalPagination: MemoizedSelector<object, number>;
  selectLoading: MemoizedSelector<object, boolean>;
  selectLoaded: MemoizedSelector<object, boolean>;
  selectFilters: MemoizedSelector<object, F[]>;
  selectError: MemoizedSelector<object, unknown>;

  protected constructor(
    public parentFeatureKey: string,
    public featureKey: string,
    public adapter: EntityAdapter<T>
  ) {
    super(parentFeatureKey, featureKey);
    this.selectAdapter = adapter?.getSelectors(this.selectState);

    this.selectIds = this.selectAdapter.selectIds;
    this.selectEntities = this.selectAdapter.selectEntities;
    this.selectAll = this.selectAdapter.selectAll;
    this.selectTotal = this.selectAdapter.selectTotal;

    this.selectCurrentEntity = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.entity);
    this.selectSelectedId = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.selectedId);
    this.selectSelectedEntity = createSelector(this.selectEntities, this.selectSelectedId, (entities, selectedId) => {
      if (!selectedId || !entities[selectedId]) {
        return null;
      }
      return entities[selectedId];
    });
    this.selectPagination = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.pagination);
    this.selectPlatformResponse = createSelector(this.selectAll, this.selectPagination, (data: T[], pagination: P) => {
      const p: any = { ...pagination };
      return {
        data,
        currentPage: p.currentPage,
        hasMore: p.hasMore,
        limit: p.limit,
        maxPage: p.maxPage,
        total: p.total
      };
    });

    this.selectLoading = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.loading);
    this.selectLoaded = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.loaded);
    this.selectFilters = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.filters);
    this.selectError = createSelector(this.selectState, (state: BaseState<T, P, F>) => state.error);
    this.selectTotalPagination = createSelector(this.selectState, (state: BaseState<T, P, F>) => {
      const p: any = { ...state.pagination };
      return p.total ?? 0;
    });
  }
}
